import { FormInput, FormTextarea, Heading, Loader } from "@/components";
import useAdd from "./useAdd";
import { FormProvider } from "react-hook-form";
import { CATEGORY_NAME, DESCRIPTION } from "./consts";
import { Button } from "@/components/ui";

const Add = () => {
  const {
    breadcrumbData,
    onBackClick,
    form,
    onSubmit,
    requiredFields,
    isAddPending,
    onCancel,
  } = useAdd();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      <Heading
        title="Add Category"
        showBack
        breadcrumbData={breadcrumbData}
        onBackClick={onBackClick}
      />

      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="bg-white mt-[20px] rounded-lg shadow-sm px-[30px] py-[25px]">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px]">
              <div>
                <FormInput
                  name={CATEGORY_NAME}
                  control={form.control}
                  label="Category Name"
                  placeholder="Please enter"
                  error={errors[CATEGORY_NAME]?.message}
                  isRequired={requiredFields.includes(CATEGORY_NAME)}
                />
              </div>
              <FormTextarea
                name={DESCRIPTION}
                control={form.control}
                label="Description"
                placeholder="Please enter"
                error={errors[DESCRIPTION]?.message}
                isRequired={requiredFields.includes(DESCRIPTION)}
              />
            </div>
          </div>
          <div className="flex flex-row justify-end gap-3  py-3">
            <Button
              variant="outline"
              type="button"
              onClick={onCancel}
              disabled={isAddPending}
            >
              Cancel
            </Button>
            <Button type="submit" disabled={isAddPending}>
              {isAddPending && <Loader variant="secondary" />}
              Save
            </Button>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default Add;
